import { useState } from "react";
import { Droplets, Check } from "lucide-react";
import { INK_COMPATIBILITY_OPTIONS } from "../../../utils/dummydata";
import { theme } from "../../../utils/theme";


const InkCompatibilityCard = ({
    form,
    setForm,
    isEditing,
    onEdit,
    onCancel,
    onSave,
    type = "printShop", // default to printShop if type is not provided
}) => {
    const selected = form.inkTypes || [];
    const t = theme[type];

    const toggle = (key) => {
        setForm((prev) => {
            const exists = prev.inkTypes?.includes(key);

            return {
                ...prev,
                inkTypes: exists
                    ? prev.inkTypes.filter((i) => i !== key)
                    : [...(prev.inkTypes || []), key],
            };
        });
    };

    return (
        <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden">

            {/* HEADER */}
            <div className="px-[20px] py-[14px] border-b border-[#f0f1f3]">
                <div className="flex items-center justify-between">
                    <p className="font-semibold text-[15px] text-[#212326]">
                        Ink Compatibility
                    </p>

                    {!isEditing ? (
                        <button
                            onClick={onEdit}
                            className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                            style={{ backgroundColor: t.primary }}
                        >
                            Edit
                        </button>
                    ) : (
                        <div className="flex items-center gap-[8px]">
                            <button
                                onClick={onCancel}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px]"
                                style={{
                                    backgroundColor: t.bg,
                                    color: t.primary,
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={onSave}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                                style={{ backgroundColor: t.primary }}
                            >
                                Save
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* VIEW MODE */}
            {!isEditing && (
                <div className="p-[20px] flex flex-wrap gap-[8px]">
                    {INK_COMPATIBILITY_OPTIONS.filter((o) => selected.includes(o.key)).map(
                        (item) => (
                            <span
                                key={item.key}
                                className={`bg-[${t.bg}] text-[${t.primary}] px-[12px] py-[6px] rounded-[10px] font-medium text-[13px] flex items-center gap-[6px]`}
                            >
                                <Droplets className="w-[12px] h-[12px]" />
                                {item.title}
                            </span>
                        )
                    )}
                </div>
            )}

            {/* EDIT MODE */}
            {isEditing && (
                <div className="p-[20px] flex flex-col gap-[10px]">
                    {INK_COMPATIBILITY_OPTIONS.map((item) => {
                        const checked = selected.includes(item.key);

                        return (
                            <label
                                key={item.key}
                                className={`flex items-center gap-[14px] px-[16px] py-[14px] rounded-[12px] border-2 cursor-pointer transition-all ${checked
                                    ? `border-[${t.primary}] bg-[${t.bg}]`
                                    : "border-[#e4e5e7] bg-white hover:border-[#c0c2c6]"
                                    }`}
                            >
                                <div
                                    className={`w-[22px] h-[22px] rounded-[6px] border-2 flex items-center justify-center shrink-0 ${checked
                                        ? `border-[${t.primary}] bg-[${t.primary}]`
                                        : "border-[#d0d2d6]"
                                        }`}
                                >
                                    {checked && (
                                        <Check className="w-[12px] h-[12px] text-white" />
                                    )}
                                </div>

                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    checked={checked}
                                    onChange={() => toggle(item.key)}
                                />

                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326]">
                                        {item.title}
                                    </p>
                                    <p className="font-medium text-[12px] text-[#9298a0]">
                                        {item.desc}
                                    </p>
                                </div>
                            </label>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default InkCompatibilityCard;